import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import AirportServices from "services/AirportServices";

const SelectAirportMultiple = ({ 
  onSelectState, 
  name, 
  label, 
  selectedServiceState = [], 
  setSelectedServiceState, 
  register,
  required
}) => {
  const [states, setStates] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);

  // Fetch states on component mount
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await AirportServices.getAllAirport();
        
        if (Array.isArray(response.data)) {
          setStates(
            response.data.map((item) => ({
              value: item.id,
              label: item.airportname,
            }))
          );
        } else {
          console.error('API Response is not an array:', response);
        }
      } catch (error) {
        console.error('Error fetching states:', error);
      }
    };

    fetchStates();
  }, []);

  const allOption = { value: "all", label: "Select All" };

  const getSelectedOptions = () => {
    if (isAllSelected) {
      return [...states];
    }
    return selectedServiceState
      .map((value) =>
        states.find((state) =>
          typeof value === 'object' ? state.value === value.value : state.value.toString() === value.toString()
        )
      )
      .filter(Boolean);
  };

  const handleStateSelect = (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === "all")) {
      setIsAllSelected(true);
      setSelectedServiceState(states);
      onSelectState(states);
    } else {
      setIsAllSelected(false);
      setSelectedServiceState(selectedOptions);
      onSelectState(selectedOptions);
    }
  };

  return (
    <div>
      {label && <label className="block text-sm font-medium">{label}</label>}
      <Select
      {...register(`${name}`, {
    ...(required && {
      required: `${label} is required!`,
    }),
  })}
        isMulti
        name={name}
        options={[allOption, ...states]}
        value={getSelectedOptions()} // Pre-select values
        onChange={handleStateSelect} // Handle changes
        placeholder="Select Airport"
        classNamePrefix="react-select"
      />
    </div>
  );
};

export default SelectAirportMultiple;
